import { connect, MapStateToProps } from 'react-redux'
import RecommendationsComponent, { Props } from '../recommendations-component/RecommendationsComponent'
import aiRecommendationsForModelDataSelector from '../../redux/selectors/recommendations/aiRecommendationsForModelDataSelector'
import aiRecommendationsRequestIsPendingSelector from '../../redux/selectors/pending-request/aiRecommendationsRequestIsPendingSelector'
import { selectEquipment } from '../../redux/actions/app/equipmentGroups.actions'
import { openInfoModal } from '../../redux/actions/app/infoModal.actions'

type StateProps = Pick<Props, 'recommendationsData' | 'isLoading'>

type DispatchProps = Pick<Props, 'selectEquipment' | 'openInfoModal' | 'trackRecommendedEquipments'>

const noOpTracking = (): void => {
    // Tracking disabled for AI recommendations for now
}

const mapDispatchToProps: DispatchProps = {
    selectEquipment,
    openInfoModal,
    trackRecommendedEquipments: noOpTracking,
}

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    recommendationsData: aiRecommendationsForModelDataSelector(state),
    isLoading: aiRecommendationsRequestIsPendingSelector(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationsComponent)
